import firebase from "../../../../Config/firebase";
import React, {Component} from "react";
import {Container, ListGroup} from "reactstrap";
import {MDBAlert} from 'mdbreact'
import Post from "../../../PostList/Post/Post";
import {withRouter} from "react-router-dom";
import ContentLoader from "react-content-loader"
import classes from './CommunityPostList.module.css'

const db = firebase.firestore()

class CommunityPostList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            posts: [],
            community: {},
            noPost: false,
            noMorePost:false
        }
    }

    componentDidMount() {
        if (typeof this.props.location.state !== "undefined") {
            if (this.props.location.state.hasOwnProperty('community')) {
                this.setState({
                    community: this.props.location.state.community
                }, () => {
                    this.getCommunityPost()
                    this.setState({
                        isLoaded: true
                    })
                })
            }
        } else {
            db.collection('Community').doc(this.props.match.params.cid)
                .get()
                .then(doc => {
                    if (doc.exists) {
                        this.setState({
                            community: doc.data()
                        }, () => {
                            this.getCommunityPost()
                            this.setState({
                                isLoaded: true
                            })
                        })
                    }
                })
                .catch(err => console.log(err))
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setState({
                community: nextProps.location.state.community,
                posts: []
            }, () => {
                this.getCommunityPost()
            })
        }
    }

    getCommunityPost = () => {
        db.collection('Post')
            .limit(8)
            .where('communityID', '==', this.state.community.communityID)
            .orderBy('createDate', 'desc')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allPost = []
                    docs.forEach(function (doc) {
                        const post = {
                            id: doc.id,
                            ...doc.data()
                        }
                        allPost.push(post)
                    })
                    this.setState({
                        posts: allPost
                    }, () => {
                        this.setState({
                            isLoaded: true
                        })
                    })
                }
                else{
                    this.setState({
                        noPost:true
                    })
                }

            })
            .catch(err => console.log(err))
    }

    render() {
        return (
            <ListGroup flush>
                {
                    this.state.isLoaded ?
                        !this.state.noPost ?
                        this.state.posts.map((post, index) => {
                            return (
                                <Post
                                    key={index}
                                    data={post}
                                />
                            )
                        })
                            :
                            <MDBAlert>
                                沒找到任何貼文
                            </MDBAlert>
                        :
                        <div className={classes.LoadingContainer}>
                            {/*<ContentLoader*/}
                            {/*    speed={2}*/}
                            {/*    width={document.getElementById('HomePageContainer').offsetWidth}*/}
                            {/*    height={600}*/}
                            {/*    backgroundColor="#ffffff"*/}
                            {/*    foregroundColor="#f2f2f2"*/}
                            {/*>*/}
                            {/*    <rect x="5" y="10" rx="8" ry="8" width={document.getElementById('HomePageContainer').offsetWidth - 20} height="157" />*/}
                            {/*    <rect x="5" y="177" rx="8" ry="8" width={document.getElementById('HomePageContainer').offsetWidth - 20} height="157" />*/}
                            {/*</ContentLoader>*/}
                        </div>

                }

            </ListGroup>
        );
    }
}

export default withRouter(CommunityPostList);